import React from "react";
import { connect } from "react-redux";
import { Outlet, useLocation } from "react-router";

import SidebarBody from "./sidebar/SidebarBody";
import SidebarHeader from "./sidebar/SidebarHeader";
import NestedSidebar from "./sidebar/NestedSidebar";
import { NO_NESTED_SIDEBAR_ROUTES, routesPathConstants } from "../../constants";
import TopbarUserContainer from "../../shared/components/topbar/TopbarUserContainer";
import { createCompanyDynamicUrl, isAdminLogin } from "../../shared/utility";

const AppLayout = ({
  isSidebarOpen,
  isNestedSidebarOpen,
  isStoreActive,
  user,
  spinnerArray,
  ...props
}) => {
  const location = useLocation();

  let noNestedSideRoutes = NO_NESTED_SIDEBAR_ROUTES.map((route) =>
    createCompanyDynamicUrl(route)
  );

  return (
    <>
      <div className="page-wrapper">
        <div className="row m-0 pe-3 topbar system-tob-bar">
          <div className="col-12  d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-4 topbar-logo-select-store-wrapper">
              <SidebarHeader />
            </div>
            <TopbarUserContainer />
          </div>
        </div>
        <div className={`d-flex`}>
          <div
            className={`sidebar sidebar-wrapper ${
              !isStoreActive && !isAdminLogin(user) && "store-inactive"
            }`}
          >
            <SidebarBody />
            <NestedSidebar />
          </div>
          <div
            className={`outlet-container ps-2 pe-1 ${
              isNestedSidebarOpen &&
              !noNestedSideRoutes.includes(location.pathname) &&
              "sidebar-opened-outlet-container"
            }`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  user: state.authentication.user,
  spinnerArray: state.system.spinnerArray,
  isSidebarOpen: state.system.isSidebarOpen,
  isNestedSidebarOpen: state.system.isNestedSidebarOpen,
  isStoreActive: state.store.currentStore.isStoreActive,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
